import Button from 'theme/overrides/Button';
// import CalendarPicker from 'theme/overrides/CalendarPicker';
import CssBaseline from 'theme/overrides/CssBaseline';
import Dialog from 'theme/overrides/Dialog';
import Drawer from 'theme/overrides/Drawer';
import FormHelperText from 'theme/overrides/FormHelperText';
import OutlinedInput from 'theme/overrides/OutlinedInput';
import Paper from 'theme/overrides/Paper';

const componentsOverrides = (theme) => {
  return Object.assign(
    Button(theme),
    // CalendarPicker(theme),
    CssBaseline(theme),
    Dialog(theme),
    Drawer(theme),
    FormHelperText(theme),
    OutlinedInput(theme),
    Paper(theme)
  );
};

export default componentsOverrides;
